import removeFromCookie from '@utils/cookies/remove-from-cookie';
import getFromCookie from '@utils/cookies/get-from-cookie';
import getParseUrl from '@utils/helpers/parse-url';
import routes from '@routes';
import localforage from 'localforage';
import removeFromLocal from '@utils/storage/remove-from-local';

//TODO: handle Catch

interface ConfigProps extends CacheProps{
  method: 'GET' | 'PUT' | 'DELETE' | 'POST'
  URL: string | {
    pathname: string,
    query: object | any
  }
  payload?: any
  userType?: 'client' | 'user' | 'admin'
  withToken?: boolean
  uploadFile?: boolean
  serverToken?: any
}

export interface CacheProps {
  cache?: 'default' | 'force-cache' | 'no-cache' | 'no-store' | 'only-if-cached' | 'reload'
  next?: {revalidate: number}
}

export const fetchApi = async({ method, payload, withToken, URL, userType, cache, next, uploadFile = false, serverToken }: ConfigProps): Promise<any> => {
  const parseUrl = getParseUrl(URL);

  const CatchFunction = async (error: any) => {
    const errorResponse = await error.json();
    const errorObject = {
      code: error?.status,
      message: errorResponse?.data?.error,
    };
    if (error?.status === 401) {
      removeFromCookie('token');
      removeFromLocal('otc_list');
      await localforage.removeItem('fcm_token');
      if (window.location.pathname) {
        if (window.location.pathname.startsWith('/mobile')) {
          window.location.replace(`/mobile${routes['route.client.login']}?redirect=${encodeURIComponent(window.location.pathname)}`);
        } else {
          window.location.replace(`${routes['route.client.login']}?redirect=${encodeURIComponent(window.location.pathname)}`);
        }
      }
    }
    throw errorObject;
  };

  // set token for Authorization
  const headers = new Headers({
    Accept: 'application/json',
  });

  const token = !!serverToken ? serverToken : getFromCookie('token');
  if (withToken) {
    headers.append('Authorization', 'Bearer ' + token);
  }

  if (!uploadFile) {
    headers.append('Content-Type', 'application/json');
  }

  let baseURL: string = '';
  if (userType === 'admin') {
    baseURL = `${process.env.API_BASE_URL}/${process.env.API_ADMIN_BASE_PATH}/${process.env.API_VERSION}`;
  } else if (userType === 'user') {
    baseURL = `${process.env.API_BASE_URL}/${process.env.API_USER_BASE_PATH}/${process.env.API_VERSION}`;
  } else {
    baseURL = `${process.env.API_BASE_URL}/${process.env.API_CLIENT_BASE_PATH}/${process.env.API_VERSION}`;
  }
  const controller = new AbortController();
  const signal = controller.signal;
  switch (method) {
    case 'GET': {
      return (
        fetch(encodeURI(`${baseURL}/${parseUrl}`), {
          headers: headers,
          next: next,
          cache: cache,
          method: 'GET',
          signal,
        })
          .then(response => {
            if (!response.ok) {
              throw response;
            }

            return response.json();
          }).then((data) => {
            return data;
          }).catch((reason) => reason.name === 'TypeError' ? controller.abort() : CatchFunction(reason))
      );
    }
    case 'PUT': {
      return (
        fetch(encodeURI(`${baseURL}/${parseUrl}`), {
          headers: headers,
          body: JSON.stringify(payload),
          cache: cache,
          next: next,
          method: 'PUT',
          signal,
        })
          .then(response => {
            if (!response.ok) {
              throw response;
            }
            return response.json();
          })
          .catch((reason) => reason.name === 'TypeError' ? controller.abort() : CatchFunction(reason))
      );
    }
    case 'DELETE': {
      return (
        fetch(encodeURI(`${baseURL}/${parseUrl}`), {
          headers: headers,
          next: next,
          cache: cache,
          method: 'DELETE',
          signal,
        })
          .then(response => {
            if (!response.ok) {
              throw response;
            }
            return response.json();
          })
          .catch((reason) => reason.name === 'TypeError' ? controller.abort() : CatchFunction(reason))
      );
    }
    case 'POST': {
      return (
        fetch(encodeURI(`${baseURL}/${parseUrl}`), {
          headers: headers,
          body: uploadFile ? payload : JSON.stringify(payload),
          next: next,
          cache: cache,
          method: 'POST',
          signal,
        })
          .then(response => {
            if (!response.ok) {
              throw response;
            }
            return response.json();
          })
          .catch((reason) => reason.name === 'TypeError' ? controller.abort() : CatchFunction(reason))
      );
    }
  }
};
